const ct = [
  {
    min: 0.30,
    max: 0.39
  },
  {
    min: 0.40,
    max: 0.49
  },
  {
    min: 0.50,
    max: 0.69
  },
  {
    min: 0.70,
    max: 0.89
  },
  {
    min: 0.90,
    max: 0.99
  },
  {
    min: 1.00,
    max: 1.49
  },
  {
    min: 1.50,
    max: 1.99
  },
  {
    min: 2.00,
    max: 2.99
  },
  {
    min: 3.00,
    max: 3.99
  },
  {
    min: 4.00,
    max: 4.99
  },
  {
    min: 5.00,
    max: 5.99
  },
  {
    min: 10.00,
    max: 10.99
  }
]

const tabs = [
  {
    name: 'pears',
    value: '0'
  },
  {
    name: 'round',
    value: '1'
  }
]

const colors = [
  'D',
  'E',
  'F',
  'G',
  'H',
  'I',
  'J',
  'K',
  'L',
  'M',
  'N'
]

const clear = [
  'VVS2',
  'VVS1',
  'VS2',
  'VS1',
  'SI3',
  'SI2',
  'SI1',
  'IF',
  'I3',
  'I2',
  'I1'
]

export {
  ct,
  tabs,
  colors,
  clear
}
